module.exports = __webpack_public_path__ + "img/approve_no.6b4af107.jpg";